import React, { useState } from 'react'
import {nthPrime} from "../utils/helper"


const Demo = () => {
    const [text, setText] = useState("")
    const [isDarkTheme, setIsDarkTheme] = useState(true);

    

    const prime =() =>{
      console.log("calculate nth prime no of", text);
      
        return(
          nthPrime(text)
          
        )
    }  
    
  return (
    <div className={'m-4 p-2 w-96 h-96 border border-black ' + (isDarkTheme && 'bg-gray-900 text-white' )}>
      <button className='m-2 p-2 bg-green-400 text-black' onClick={()=>setIsDarkTheme(!isDarkTheme)}>Toggle</button>
      <div>
          <input type="number" 
             value={text}
             onChange={(e)=>setText(e.target.value)} 
             className=' w-full p-2 border border-black bg-white text-black'
      />
      </div>
      
      <div>
        <h1>{prime()}</h1>
      </div>
    </div> 
  )
}

export default Demo
